import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ListenerDetailAction, ResponseConfirmation } from '../../global';
import { BusService } from '../../services/bus.service';

export interface DialogData {
  title: '';
  message: '';
}

@Component({
  selector: 'app-tin-dialog',
  templateUrl: './tin-dialog.component.html',
  styleUrls: ['./tin-dialog.component.scss']
})

export class TinDialogComponent implements OnInit  {

  isMobile = false;
  textareaValue = '';
  username = '';
  inputCheck = '';
  errorInputCheck = false;
  errorRequiredTextarea = false;

  constructor(
    public dialogRef: MatDialogRef<TinDialogComponent>,
    private deviceService: DeviceDetectorService,
    private serviceBus: BusService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.isMobile = this.deviceService.isMobile();
    }

  ngOnInit(): void {
    
    this.username = this.data.username;

  }

  inputEnter(){
    this.yes();
  }

validateUser(){ 
  return (!this.data.userCheck || this.inputCheck.trim().toLowerCase() === this.username.trim().toLowerCase());
}

validateUserOkay(){ 
  return this.inputCheck?.trim().toLowerCase() === 'okay'; 
}

  validateRequiredTextarea(){
    if(this.data.textareaRequired){
      if(this.textareaValue){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }

  no(): void {
    this.dialogRef.close({response: ResponseConfirmation.No});
  }

  yes(): void {
    this.validateConfirmationBox();
    if(!this.errorInputCheck && !this.errorRequiredTextarea){
      this.dialogRef.close({response: ResponseConfirmation.Yes, item:{text : this.textareaValue}});
    }
  }

  ok() {
    this.validateConfirmationBox();
    if(!this.errorInputCheck && !this.errorRequiredTextarea){
      this.dialogRef.close({response: ResponseConfirmation.Ok, item:{text : this.textareaValue}});
    }
  }

  saveAndSend(){
    this.dialogRef.close({response: ResponseConfirmation.SaveAndSend, item:{text : this.textareaValue}});
  }

  save() {

    this.serviceBus.sendMessageToDetail(ListenerDetailAction.Save);
    this.serviceBus.hasUnsavedChanges = false;

    setTimeout(() => {
      this.dialogRef.close({response: ResponseConfirmation.Yes, item:{text : this.textareaValue}});
    }, 0);

   }
   cancel(){

    this.serviceBus.sendMessageToDetail(ListenerDetailAction.Cancel);
    this.serviceBus.hasUnsavedChanges = false;
    setTimeout(() => {
      this.dialogRef.close({response: ResponseConfirmation.Yes});
    }, 0);

   }

   textareaChange(e:any){
    this.textareaValue = e.target.value.trimStart();
   }

  validateConfirmationBox(){
    if (this.data.userCheck) {
      const forceOkay = this.data.className === 'force-okay';
      this.errorInputCheck = !(forceOkay ? this.validateUserOkay() : this.validateUser());
    } else {
      this.errorInputCheck = false;
    }
    this.errorRequiredTextarea = !this.validateRequiredTextarea();
  }

  customAction(){
    if (this.data.customFonction) {
      this.data.customFonction();
      this.dialogRef.close({response: ResponseConfirmation.Yes});
    }
  }

}
